import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "a431f3c2-cec1-446d-94ee-975086f93fd3",
    content: "a = 10 cm, f = 1000 Hz",
    options: {},
  },
  {
    id: "c7347f19-f245-4b23-a6c1-a83b3acd66c4",
    content: "a = 1 cm, f = 5000 Hz",
    options: {},
  },
  {
    id: "a22d9fc4-6baf-4080-a308-f5cfad10aef1",
    content: "a = 20 cm, f = 1500 Hz",
    options: {},
  },
  {
    id: "94207614-0475-488d-ab31-a51dd28cdc6f",
    content: "a = 1 cm, f = 10 kHz",
    options: {},
  },
  {
    id: "7334dfdb-8c53-4ea7-90aa-6a9850001cf0",
    content: "a = 18 cm, f = 1000 Hz",
    options: {},
  },
  {
    id: "149b11c1-8070-4b05-b1a4-4ff4d36606e2",
    content: "a = 2 cm, f = 7000 Hz",
    options: {},
  },
];

export const task: Task = {
  id: "bdffc0e3-83a3-441b-b2df-0279c56349ad",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["a22d9fc4-6baf-4080-a308-f5cfad10aef1"],
};
